import Flickity from "flickity";
import { $1, $, each } from "../util";

const CarouselManager = (() => {
  const initMain = () => {
    const mainSlider = $(".js-main-slider");
    const prev = $(".js-prev");
    const next = $(".js-next");

    each(mainSlider, (i, mainSl) => {
      const progress = $1(".js-main-slider-progress-bar");

      const options = {
        cellSelector: ".c-main-slide",
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: false,
      };

      // if (window.matchMedia('(min-width: 1024px)').matches) {
      //   options.draggable = false
      // } else {
      //   options.draggable = true
      // }

      const mainSliderInstance = new Flickity(mainSl, options);

      progress.style.width = `${100 / mainSliderInstance.slides.length}%`;

      each(prev, (l, p) => {
        p.addEventListener("click", () => {
          mainSliderInstance.previous(true);
        });
      });

      each(next, (k, n) => {
        n.addEventListener("click", () => {
          mainSliderInstance.next(true);
        });
      });

      mainSliderInstance.on("change", () => {
        progress.style.width = `${
          ((mainSliderInstance.selectedIndex + 1) * 100) /
          mainSliderInstance.slides.length
        }%`;
      });
    });
  };

  const initHomeCase = () => {
    const homeCaseSlider = $1(".c-home-case-slider");

    if (homeCaseSlider) {
      const progress = homeCaseSlider.querySelector(
        ".js-main-slider-progress-bar"
      );
      const prev = homeCaseSlider.querySelector(".js-prev");
      const next = homeCaseSlider.querySelector(".js-next");

      const options = {
        cellSelector: ".c-home-case-slide",
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: false,
      };

      const homeCaseInstance = new Flickity(homeCaseSlider, options);

      progress.style.width = `${100 / homeCaseInstance.slides.length}%`;

      prev.addEventListener("click", () => {
        homeCaseInstance.previous(true);
      });

      next.addEventListener("click", () => {
        homeCaseInstance.next(true);
      });

      homeCaseInstance.on("change", () => {
        progress.style.width = `${
          ((homeCaseInstance.selectedIndex + 1) * 100) /
          homeCaseInstance.slides.length
        }%`;
      });
    }
  };

  const initHomeBlog = () => {
    const homeBlogSlider = $1(".c-home-blog-slider");

    if (homeBlogSlider) {
      const progress = homeBlogSlider.querySelector(
        ".js-main-slider-progress-bar-blog"
      );
      const prev = homeBlogSlider.querySelector(".js-prev-blog");
      const next = homeBlogSlider.querySelector(".js-next-blog");

      const options = {
        cellSelector: ".c-home-blog-slide",
        // wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: false,
        contain: true,
        groupCells: true,
      };

      const homeBlogInstance = new Flickity(homeBlogSlider, options);

      progress.style.width = `${100 / homeBlogInstance.slides.length}%`;

      prev.addEventListener("click", () => {
        homeBlogInstance.previous(true);
      });

      next.addEventListener("click", () => {
        homeBlogInstance.next(true);
      });

      homeBlogInstance.on("change", () => {
        progress.style.width = `${
          ((homeBlogInstance.selectedIndex + 1) * 100) /
          homeBlogInstance.slides.length
        }%`;
      });
    }
  };

  const initHomeSlider = () => {
    const slider = $1(".c-hero__claim-slider");

    if (slider) {
      const homeSliderInstance = new Flickity(slider, {
        cellSelector: ".c-hero__claim-slide",
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: false,
        autoPlay: 4000,
      });
    }
  };

  const init = () => {
    initMain();
    initHomeCase();
    initHomeSlider();
    initHomeBlog();
  };

  return {
    init,
  };
})();

export default CarouselManager;
